module.exports = __webpack_public_path__ + "img/5.461c588c.png";